import constants from './constants';

const initialState = {
  token: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constants.actions.RECEIVE_TOKEN:
      return {
        ...state,
        token: action.token,
      };
    default:
      return state;
  }
}
